module.exports = __webpack_public_path__ + "static/amit-7375f5c620eb81f59b6f6a60cc1125cd.jpg";